// extracted by mini-css-extract-plugin
module.exports = {"container":"GroceryListBanner_container__8l754","image":"GroceryListBanner_image__iRWwj","content":"GroceryListBanner_content__dHISd","actions":"GroceryListBanner_actions__9a9ec"};